import { useState } from "react";

export default function BeforeAfter({ beforeSrc, afterSrc, title }) {
  const [pos, setPos] = useState(50);

  return (
    <div
      className="group relative aspect-[4/3] w-full select-none overflow-hidden border border-white/10 bg-joell-surface"
      data-testid="before-after-comparison"
    >
      <img src={afterSrc} alt={`${title} — after`} className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
      <img
        src={beforeSrc}
        alt={`${title} — before`}
        className="absolute inset-0 h-full w-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        loading="lazy"
      />

      <span className="pointer-events-none absolute left-3 top-3 bg-joell-black/80 px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-white">
        Before
      </span>
      <span className="pointer-events-none absolute right-3 top-3 bg-joell-yellow px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-joell-black">
        After
      </span>

      <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-joell-yellow" style={{ left: `${pos}%` }}>
        <span className="absolute left-1/2 top-1/2 flex h-9 w-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center border-2 border-joell-yellow bg-joell-black/90 font-mono text-[10px] font-bold text-joell-yellow">
          ↔
        </span>
      </div>

      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label={`Before and after slider for ${title}`}
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
        data-testid="before-after-slider"
      />
    </div>
  );
}
